import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useState, useRef } from 'react';
import CallMeModal from '../CallMeModal/CallMeModal';
import track, { errorTypes } from 'c9-tracking';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { isLoggedOnSelector } from '../../recoil/selectors/isLoggedOnSelector';

const ErrorModal = ({ retry }: { retry?: () => void }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [openErrorModal, setOpenErrorModal] = useState(true);
    const closeModal = (): void => {
        window.location.href = '/';
    };
    const activityCode = 'dss_unexpected_error_phone_req';
    const hasCalledTrackingRef = useRef(false);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    if (openErrorModal) {
        if (!hasCalledTrackingRef.current) {
            void track.fault(
                `Customer encountered an error modal, errorcode: ${activityCode}`,
                errorTypes.tech
            );
            hasCalledTrackingRef.current = true;
        }
    }

    return (
        <div id="error-modal">
            <ModalOverlay isOpen={openErrorModal} id="modal-dialog">
                <ModalDialog closeIconHandler={closeModal}>
                    <div className="u-spacing-inset-l">
                        <div className="u-spacing-inset-l--stretch-max">
                            <h4 className="u-spacing-stack-sm">
                                {getHippoText('DSS-UNEXPECTED-ERROR-MODAL-HEADER')}
                            </h4>
                            <p className="u-spacing-stack-none">
                                {isLoggedOn
                                    ? getHippoText('DSS-UNEXPECTED-ERROR-MODAL-SUBHEADER')
                                    : getHippoText(
                                          'DSS-UNEXPECTED-ERROR-MODAL-UNIDENTIFIED-CUSTOMER-SUBHEADER'
                                      )}
                            </p>
                        </div>
                        <Button onClick={retry} id="error-retry-button">
                            Prøv igen
                        </Button>
                        <Button
                            theme={'secondary'}
                            onClick={() => {
                                setOpenErrorModal(false);
                            }}
                            id="error-callme-button"
                        >
                            Ring mig op
                        </Button>
                    </div>
                </ModalDialog>
            </ModalOverlay>
            <CallMeModal
                activityCode={activityCode}
                showModal={!openErrorModal}
                closeModal={closeModal}
                setOpenErrorModal={setOpenErrorModal}
            />
        </div>
    );
};

export default ErrorModal;
